import {Link} from 'react-router-dom';
import {useI18n} from '../../../providers/I18nProvider';
import {routes} from '../../../../routing/routes';

export default function Footer() {
	const {i18n} = useI18n();
	return (
		<div className='flex justify-between items-center py-6 px-7.5 '>
			<div className='text-sm font-medium text-muted'>2023 &copy; Knower</div>

			<div className='flex items-center'>
				<Link
					className='text-sm font-medium mr-4.5 text-muted'
					target='_blank'
					to={routes.term}
					style={{textDecoration: 'revert'}}
				>
					{i18n('LAYOUT.FOOTER.BUTTON.TERMS')}
				</Link>
				<Link
					className='text-sm font-medium text-muted'
					target='_blank'
					to={routes.privacy}
					style={{textDecoration: 'revert'}}
				>
					{i18n('LAYOUT.FOOTER.BUTTON.PRIVACY')}
				</Link>
			</div>
		</div>
	);
}
